<template>
    <el-dialog title="线索导入" :visible.sync="show" width="30%">
        <div style="text-align: center">
            <el-upload class="upload-demo" accept=".xlsx" drag action :file-list="uploadFiles"
                :http-request="uploadRequest" :limit="1" :on-success="uploadSuccess" :on-remove="uploadRemove"
                :before-upload="uploadBefore">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
            </el-upload>
            <div>
                <a href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/template/%E7%BA%BF%E7%B4%A2%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
                    class="table-href">
                    下载模版
                </a>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" :loading="uploadLoading" @click="handleSubmit">
                确定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import oss from "@/utils/ali-oss";
export default {
    name: 'import-clue',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        },
        show(newVal) {
            this.$emit('update:visible', newVal);
        },
    },
    data() {
        return {
            show: false,
            uploadFiles: [],
            uploadFile: '',
            uploadLoading: false
        }
    },
    methods: {
        uploadRequest(option) {
            oss.ossUploadFile(option);
        },
        uploadBefore(file) {
            if (
                file.type !=
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
                this.$message.error("请上传xlsx格式文件!");
                return false;
            }
        },
        uploadSuccess(res, file) {
            this.uploadFile = res;
        },
        uploadRemove(file, fileList) {
            this.uploadFile = "";
        },
        cancel() {
            this.uploadFiles = []
            this.uploadFile = "";
            this.show = false;
        },
        handleSubmit() {
            if (this.uploadFile === "") {
                this.$message({
                    message: "请选择导入文件",
                    type: "warning",
                });
                return;
            }
            this.uploadLoading = true;
            this.$httpAuth
                .post("/v1/backendClueRpc/import", {
                    file: this.uploadFile,
                })
                .then((response) => {
                    this.uploadLoading = false;
                    if (response.data.code == 1004 && response.data.status == -2) {
                        this.$notify({
                            title: "导入结果",
                            dangerouslyUseHTMLString: true,
                            message: response.data.detail
                        }); 
                    } else {
                        this.$notify({
                            title: "导入结果",
                            dangerouslyUseHTMLString: true,
                            message: `<strong>插入 <i>${response.data.successCount}</i> 条线索</strong><br><strong>失败 <i>${response.data.failedCount}</i> 条线索</strong>`
                        });
                    }
                    this.cancel();
                    this.emit('reset');
                })
                .catch(function (error) {
                    this.uploadLoading = false;
                    return;
                });
        },
    }
}
</script>